const userDataFormValidationDE = {
    "firstName": {
        "required": "Vorname ist erforderlich"
    },
    "lastName": {
        "required": "Nachname ist erforderlich"
    },
    "personalStreet": {
        "required": "Straße und Hausnummer sind erforderlich"
    },
    "personalZip": {
        "required": "Postleitzahl ist erforderlich"
    },
    "personalCity": {
        "required": "Stadt ist erforderlich"
    },
    "personalCountry": {
        "required": "Land ist erforderlich"
    },
    "businessType": {
        "required": "Geschäftstyp ist erforderlich"
    },
    "companyName": {
        "required": "Firmenname ist erforderlich"
    },
    "ceoFirstName": {
        "required": "Vorname des Geschäftsführers ist erforderlich"
    },
    "ceoLastName": {
        "required": "Nachname des Geschäftsführers ist erforderlich"
    },
    "businessStreet": {
        "required": "Straße und Hausnummer sind erforderlich"
    },
    "businessZip": {
        "required": "Postleitzahl ist erforderlich"
    },
    "businessCity": {
        "required": "Stadt ist erforderlich"
    },
    "businessCountry": {
        "required": "Land ist erforderlich"
    },
    "tradeRegistryExport": {
        "file": "Bitte laden Sie eine gültige PDF-Datei hoch (maximale Größe 5 MB)."
    },
    "tradeRegistryExportURL": {
        "required": "Handelsregisterauszug ist erforderlich"
    },
    "tradeRegistryCompanyUrl": {
        "required": "URL des Handelsregisterunternehmens ist erforderlich"
    }
};

export default userDataFormValidationDE;